import moment from 'moment-timezone';
export const TIMEZONE = 'Etc/GMT';
export const BT_START = moment.unix(1349222400).tz(TIMEZONE); // Wed Oct 03 2012


// WEBPACK FOOTER //
// ./src/config/constants.js